<template>
  <div id="app">
    <div class="container-fluid container-md flex-grow-1">
    <div class="row h-100 viewContainer" :class="{map: mapView}">
      <div id="list" class="col pr pr-sm-1" style="min-height: 60vh;">
        <div class="h-100  d-flex flex-column">
          <div class="row justify-content-center">
            <div class="col">
              <div class="form-group mb-0">
                <input type="text" class="form-control" :class="{filled: searchTerm}" v-model="searchTerm" >
                <label> {{ $t('widget.studio.searchPlaceholder') }}</label>
              </div>
              <div class="row d-sm-none">
                <div class="col text-right mt-1">
                  <button @click="map()" class="btn btn-primary btn-sm"><i class="fas fa-map-marked-alt"></i> {{  $t('widget.studio.mapView') }}</button>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <div class="hr mx-0"><span>{{ $t('widget.studio.clubList') }}</span></div>
            </div>
          </div>
          <studio-list class="flex-grow-1"  @clicked="onStudioChanged" :studios="studios" :selected-studio="studio"></studio-list>
        </div>
      </div>
      <div id="mapview" class="col px-0 pl-sm-3 d-none d-sm-block" style="min-height: 60vh;">
        <div class="row h-100">
          <div class="row px-3 d-sm-none">
            <div class="col ">
              <a href="#" class="btn btn-sm" @click="mapView = false"><i class="fas fa-arrow-left"></i> {{ $t('common.previous') }}</a>
            </div>
          </div>
          <GmapMap
              :center="center"
              :zoom="9"
              :options="maps"
              style="width: 100%; height: 100%;"
          >
            <gmap-cluster
                :gridSize="30"
                :zoomOnClick="true"
                :enableRetinaIcons="true"
                :minimumClusterSize="5"
                ref="cluster">
              <GmapMarker
                  :key="index"
                  v-for="(m, index) in studios"
                  :position="getMarkerPosition(m)"
                  :clickable="true"
                  :draggable="false"
                  :icon="getMarkerIcon(m)"
                  @click="toggleInfoWindow(m, index)"
              />
            </gmap-cluster>
            <gmap-info-window
                :options="infoOptions"
                :position="infoWindowPos"
                :opened="infoWinOpen"
                @closeclick="infoWinOpen=false"
            >
              <div class="container-fluid infobox" v-if="selectedStudio">
                <div class="title" style="font-weight: bold; font-size: 1.8em; line-height: 1.4em; font-family: URWDINCond-Black;">
                  {{selectedStudio.name}}
                  <span v-if="selectedStudio.comingsoon && !selectedStudio.opening" class="badge bg-dark rounded-pill text-white px-3 d-inline-block ml-2 text-uppercase">Opening Soon</span>
                  <span v-if="selectedStudio.opening" class="badge bg-dark rounded-pill text-white px-3 d-inline-block ml-2 text-uppercase">{{ $t('common.opening', {date: selectedStudio.opening}) }}</span>
                  <span v-if="selectedStudio.customTag" class="badge bg-dark rounded-pill text-white px-3 d-inline-block ml-2 text-uppercase">{{ selectedStudio.customTag }}</span>
                </div>
                <hr>
                <address>
                  {{selectedStudio.addressStreet}}<br>
                  {{selectedStudio.addressZipcode}} {{selectedStudio.addressCity}}
                </address>
                <div class="text-right">
                  <strong>Tel:</strong>
                  {{selectedStudio.addressPhone}}
                </div>
                <div class="text-right">
                  <strong>Mail:</strong>
                  {{selectedStudio.addressMail}}
                </div>
                <a href="#" class="btn first btn-block" style="margin-top: 15px !important; padding-top: 0;" @click="selectStudio(selectedStudio)">Wählen</a>
              </div>
              <div v-html="infoContent"></div>
            </gmap-info-window>

          </GmapMap>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import $ from "jquery/dist/jquery.min"
import StudioList from "@/components/StudioList";

export default {
  name: 'App',
  components: {
    StudioList
  },
  data(){
    return {
      mapView: false,
      searchTerm: "",
      searchDelay: null,
      studio: null,
      studios: [],
      infoContent: '',
      infoOptions: {
        minWidth: 230,
        pixelOffset: {
          width: 0,
          height: 230
        }
      },
      infoWindowPos: {
        lat: 0,
        lng: 0
      },
      infoWinOpen: false,
      maps: {
        mapTypeControl: false,
        fullscreenControl: true,
        streetViewControl: false,
        styles: [{"featureType":"administrative","elementType":"labels.text.fill","stylers":[{"color":"#777777"}]}, {"featureType": "administrative.province","elementType": "all","stylers": [{"visibility": "off"}]},{"featureType":"landscape","elementType":"all","stylers":[{"color":"#f7f7f7"}]},{"featureType":"poi","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"road","elementType":"all","stylers":[{"saturation":-100},{"lightness":45}]},{"featureType":"road.highway","elementType":"all","stylers":[{"visibility":"simplified"}]},{"featureType":"road.arterial","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"transit","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"water","elementType":"all","stylers":[{"color":"#e1e1e1"},{"visibility":"on"}]}]
      },
      center:{lat:46.856570, lng:8.218383}
    };
  },
  watch:{
    searchTerm(){
      clearTimeout(this.searchDelay);
      this.searchDelay = setTimeout(() => {
        this.loadStudios();
      }, 300);
    }
  },
  mounted(){
      const html = document.documentElement // returns the html tag
      this.$i18n.locale = html.getAttribute('lang');
      this.loadStudios();
  },
  methods: {
    loadStudios(){

      this.axios.get("wp-admin/admin-ajax.php?action=mapdata&fnc=studioMapSearch",{params: {term: this.searchTerm, lang: this.$i18n.locale}}).then(res => {
      //this.axios.get("map.js",{params: {term: this.searchTerm, lang: this.$i18n.locale}}).then(res => {
        this.studios = res.data.studios;
      }).catch(error => {alert("Ein Fehler ist aufgetreten"); });
    },
    map(){
      this.mapView = true;
    },
    onStudioChanged(studio){
      window.location = studio.url;
    },
    toggleInfoWindow: function (marker, idx) {
      this.infoWindowPos = this.getMarkerPosition(marker);
      this.infoContent = this.getInfoWindowContent(marker);
      this.selectedStudio = marker;
      this.center = this.getMarkerPosition(marker);

      //check if its the same marker that was selected if yes toggle
      if (this.currentMidx == idx) {
        this.infoWinOpen = !this.infoWinOpen;
      }
      //if different marker set infowindow to open and reset current marker index
      else {
        this.infoWinOpen = true;
        this.currentMidx = idx;
      }

      $('.gm-style-iw-t .gm-style-iw.gm-style-iw-c').css('padding', 0);
    },
    getMarkerPosition(marker){
      return {lat: marker.coordsLat , lng: marker.coordsLng};
    },
    getMarkerIcon(marker){

      if(marker === this.selectedStudio){
        return{
          url: "/studiosearch/img/kreuz_svgmap_orange.svg",
          anchor: {x: 20, y: 0},
          scaledSize: {width:40, height:40},
        };
      }

      if(marker.comingsoon){
        return{
          url: "/studiosearch/img/kreuz_svgmap_red.svg",
          anchor: {x: 20, y: 40},
          scaledSize: {width:40, height:40},
        };
      }

      return  {
        url: "/studiosearch/img/kreuz_svgmap.svg",
        anchor: {x: 20, y: 0},
        scaledSize: {width:40, height:40},
      };
    },
    selectStudio(studio){
      //this.$store.dispatch("setStudio", {studio: studio});
      //this.center = this.getMarkerPosition(studio);
      this.$emit("studioSelect", studio);
      window.location = studio.url;
      //this.$store.commit("SET_STEP", {step: 1});
    },

    getInfoWindowContent: function (marker) {

      return (
          `
        `);
    },
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
